<app-dashboard-container
	class="dashboard-onderwijsresultaten"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentFilters(), $event)"
>
	<app-filter-panel
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/onderwijsresultaten"
		[permanentFilterExpressions]="filterPanelPermanentFilters()"
		[leerlingselectie]="false"
	></app-filter-panel>
	<app-filter-bar></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			@if (variant() === DashboardVariant.ACTUEEL) {
				<div class="cl-header-subtitle">
					<span>{{ getSchooljarenCaption() }}</span>
					@if (schooljaar) {
						<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="getSchooljarenTooltip()"></app-icon>
					}
				</div>
			}
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-schooljaar-indicator-over schooljaarFilterName="x_onderwijsresultaten_or_schooljaar"></app-schooljaar-indicator-over>
			<div class="inspectiedata-toggle">
				<app-checkbox
					label="Inspectiedata"
					[value]="useInspectieData()"
					(valueChange)="qp.dispatch('inspectie-data', $event)"
				></app-checkbox>
				<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="inspectiedataTooltip"></app-icon>
			</div>
			@if (variant() === DashboardVariant.ACTUEEL) {
				<div class="inspectiedata-toggle">
					<app-checkbox label="Trendindicaties" [value]="toonTrend()" (valueChange)="qp.dispatch('toon-trend', $event)"></app-checkbox>
					<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="trendindicatiesTooltip"></app-icon>
				</div>
			}
			<app-legenda
				class="cl-header-utility"
				[attribute]="[variant() === DashboardVariant.ACTUEEL ? 'x_onderwijsresultaten_actueel' : 'x_onderwijsresultaten_historie']"
				[keyIsClassName]="true"
			></app-legenda>
		</app-dashboard-header>
		<app-card-list
			[config]="this"
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilters()"
			[groups]="groups"
			[subgroups]="subGroups"
			[template]="cardTemplate"
			[sortMeasure]="heeftOnvoldoendePillMeasure"
			[elementPageBreak]="true"
			class="onderwijsresultaat"
			[class.historie]="variant() === DashboardVariant.HISTORIE"
			data-exportable
		>
			<ng-template #cardTemplate let-row="row" let-context="context" let-group="group">
				<div class="card-header">
					<div class="card-name">
						<h2>
							@if (row[1].a.or_m_nm_vestigingen) {
								{{ row[1].a.or_m_nm_vestigingen }}
							} @else {
								{{ group.or_co_brinvest }}
							}
						</h2>
						<span class="card-code">{{ group.or_co_brinvest }}</span>
					</div>
					<div class="badges-onvoldoende">
						@for (label of getOnvoldoendeLabels(row, peiljaar!); track label) {
							<div class="badge-onvoldoende">
								<app-icon name="alert" color="typography-4" size="small"></app-icon>
								{{ label }}
							</div>
						}
					</div>
				</div>
				<div class="card-content">
					<div
						[class.card-actueel]="variant() === DashboardVariant.ACTUEEL"
						[class.card-single-historie]="variant() === DashboardVariant.HISTORIE"
					>
						<div class="card-cell-op" (click)="onClick(row, 'op')">
							<app-card-or-cell
								[inputRows]="getCellRows(variant(), row, 'op', peiljaar!, peiljaren, aantalJaren, context.filter)"
								title="Onderwijspositie"
								[variant]="variant()"
								[template]="onderwijsPositieTemplate"
							>
								<ng-template #onderwijsPositieTemplate let-cellRow="cellRow">
									<app-card-or-single-cell [variant]="variant()" [row]="cellRow"> </app-card-or-single-cell>
								</ng-template>
							</app-card-or-cell>
						</div>
						<div class="card-cell-obs" (click)="onClick(row, 'obs')">
							<app-card-or-cell
								[inputRows]="getCellRows(variant(), row, 'obs', peiljaar!, peiljaren, aantalJaren, context.filter)"
								title="Onderbouwsnelheid"
								[variant]="variant()"
								[template]="onderbouwsnelheidTemplate"
							>
								<ng-template #onderbouwsnelheidTemplate let-cellRow="cellRow">
									<app-card-or-single-cell [variant]="variant()" [row]="cellRow"> </app-card-or-single-cell>
								</ng-template>
							</app-card-or-cell>
						</div>
					</div>
					<div
						[class.card-actueel]="variant() === DashboardVariant.ACTUEEL"
						[class.card-row-historie]="variant() === DashboardVariant.HISTORIE"
					>
						<div class="card-cell-bbs" (click)="onClick(row, 'bbs')">
							<app-card-or-cell
								[inputRows]="getCellRows(variant(), row, 'bbs', peiljaar!, peiljaren, aantalJaren, context.filter)"
								title="Bovenbouwsucces"
								[variant]="variant()"
								[template]="bovenbouwSuccesTemplate"
							>
								<ng-template #bovenbouwSuccesTemplate let-cellRow="cellRow">
									<app-card-or-row-cell [variant]="variant()" [row]="cellRow"> </app-card-or-row-cell>
								</ng-template>
							</app-card-or-cell>
						</div>
						<div class="card-cell-exc" (click)="onClick(row, 'exc')">
							<app-card-or-cell
								[inputRows]="getCellRows(variant(), row, 'exc', peiljaar!, peiljaren, aantalJaren, context.filter)"
								title="Examencijfers"
								[peiljaar]="peiljaar!"
								[aantalJaren]="aantalJaren"
								[variant]="variant()"
								[template]="examencijfersTemplate"
							>
								<ng-template #examencijfersTemplate let-cellRow="cellRow">
									<app-card-or-row-cell [variant]="variant()" [row]="cellRow"> </app-card-or-row-cell>
								</ng-template>
							</app-card-or-cell>
						</div>
					</div>
				</div>
			</ng-template>
		</app-card-list>
	</section>
</app-dashboard-container>
